import { z } from "zod";

// Validation Schema
export const productSchema = z.object({
  name: z.string().min(3, "Product name must be at least 3 characters"),
  category_id: z.string().min(1, "Please select a category type"),
  subcategory_id: z.number().min(1, "Please select a subcategory"),
  vendor_id: z.string().min(1, "Please select a vendor"),
  location_id: z.array(z.string()).optional(),
  description: z.string().min(10, "Description must be at least 10 characters"),
  qty: z.coerce.number().min(1, "Quantity must be at least 1"), // Allow strings and numbers
  amount: z.coerce.number().min(0.01, "Price must be greater than 0"), // Allow strings and numbers
  discount: z.coerce
    .number() // Allow strings and numbers
    .min(0, "Discount cannot be negative")
    .max(100, "Discount cannot exceed 100%"),
  status: z.boolean({
    required_error: "Please select availability status", // Error if nothing is selected
    invalid_type_error: "Status must be either true or false", // Error if not a boolean
  }),
  images: z
    .instanceof(File, { message: "Product image is required" })
    .optional() // Make image optional
    .refine(
      (file) => !file || file.size <= 5_000_000, // Max file size: 5MB
      "File size should be less than 5MB"
    )
    .refine(
      (file) =>
        !file || ["image/jpeg", "image/png", "image/webp"].includes(file.type), // Allowed file types
      "Only .jpg, .png, and .webp formats are supported"
    ),
});

export type ProductFormValues = z.infer<typeof productSchema>;
